/**
 * Settings — merchant-facing hub for tools that live outside Campaigns / Rewards.
 * (No persisted shop preferences in this slice; see subtitle for scope.)
 */

import { Page, Card, BlockStack, Text, InlineStack, Button } from "@shopify/polaris";

function SettingsPage() {
  return (
    <Page
      title="Settings"
      subtitle="Review security activity and get help. How games and rewards appear on your storefront is set in Campaigns and Reward policies."
    >
      <BlockStack gap="400">
        <Card>
          <BlockStack gap="400">
            <InlineStack align="space-between" blockAlign="center" wrap>
              <BlockStack gap="200">
                <Text as="h2" variant="headingMd">
                  Fraud detection
                </Text>
                <Text as="p" tone="subdued">
                  View flags, review activity, and block or unblock players when needed.
                </Text>
              </BlockStack>
              <Button url="/settings/fraud" variant="primary">
                Open fraud tools
              </Button>
            </InlineStack>
          </BlockStack>
        </Card>

        <Card>
          <BlockStack gap="400">
            <Text as="h2" variant="headingMd">
              Help and resources
            </Text>
            <Text as="p" tone="subdued">
              Documentation and support for using this app with your store.
            </Text>
            <InlineStack gap="300" wrap>
              <Button url="https://beyondgames.shop/docs" external>
                Documentation
              </Button>
              <Button url="https://beyondgames.shop/support" external>
                Contact support
              </Button>
            </InlineStack>
          </BlockStack>
        </Card>
      </BlockStack>
    </Page>
  );
}

export default SettingsPage;
